<template>
  <div
    class="login_box"
    :style="{
      height: loginHeight,
      backgroundPositionY: PCshow ? '-150px' : '',
    }"
  >
    <!-- <hhead></hhead> -->
    <div class="loginHeader" style="display: flex;">
      <img
        @click="push"
        :style="{
          marginLeft: PCshow ? '350px' : 'auto',
          marginTop: '8px',
          height: '37px',
          marginRight: PCshow ? '' : 'auto',
          cursor: 'pointer',
        }"
        src="../../../assets/newLogo-white.png"
        alt=""
      />
      <span
        v-if="PCshow"
        style="font-size: 18ox;color: #3A4260;border-left: 1px solid #DBDDE3;padding-left: 15px;margin-left: 10px;height: 20px;margin-top: 18px;line-height: 21px;"
        >忘记密码</span
      >
    </div>

    <div
      class="msg1"
      style="background: none;margin-top: 30px;width: 110%;"
      v-if="PCshow"
    >
      <div class="banner" style="padding-left: 356px !important;">
        <h2 style="font-size: 36px;">杰宜斯云，用心为您服务</h2>
        <p style="font-size: 16px;">
          提供杰宜斯金融软件终端产品帮助中心、多账户金融终端、交易分析评估等增值服务，
          <br />
          实现期货投资业务的深度支持，致力于为客户打造一个开放、贴身的金融服务云环境。
        </p>

        <img src="https://yunsrvwebapi.jeesit.com/img/cloud.png" alt="" />
        <span>扫码关注公众号</span>
        <!-- 注册和登录按钮 -->
      </div>
    </div>

    <!-- <nnav></nnav> -->
    <div class="forgetpwd">
      <div class="form" :style="{ right: loginRight }">
        <h2>忘记密码</h2>
        <div class="msg">
          <div class="inp">
            <img
              style="width: 11px;height: 16px;"
              src="../../../assets/images/login/sj.png"
              alt=""
            />
            <el-input
              @blur="phone_blur"
              v-model="phone"
              placeholder="手机号"
              maxlength="11"
            ></el-input>
            <p
              style="position: absolute;bottom: -25px;left: 0;"
              v-show="phone_msg"
            >
              请输入有效的手机号
            </p>
          </div>

          <div class="inp">
            <img
              style="width: 13px;height: 15px;"
              src="../../../assets/images/login/yzm.png"
              alt=""
            />
            <el-input
              v-model="imgcode"
              placeholder="请输入图形验证码"
              maxlength="11"
            ></el-input>
            <p
              @click="refreshCode"
              :style="{
                position: 'absolute',
                top: '31px',
                right: '0px',
                width: '100px',
                height: '64px',
              }"
            >
              <Sidentify :identifyCode="identifyCode"> </Sidentify>
            </p>
            <p v-show="code_msg" style="position: absolute;bottom: -25px;">
              验证码错误
            </p>
          </div>
          <div class="inp">
            <img
              style="width: 12px;height: 16px;"
              src="../../../assets/images/login/dx.png"
              alt=""
            />
            <el-input
              v-model="phonecode"
              placeholder="请输入短信验证码"
              maxlength="11"
            ></el-input>
            <div class="code" v-if="code_show" @click="getcode">
              获取短信验证码
            </div>
            <div class="code" v-if="!code_show">重新获取({{ count }})</div>
            <p
              v-show="code_msg1"
              style="position: absolute;bottom: -25px;left: 0;"
            >
              短信验证码错误
            </p>
          </div>
          <div class="inp">
            <img
              style="width: 12px;height: 16px;"
              src="../../../assets/images/login/mm.png"
              alt=""
            />
            <el-input
              v-model="pwd"
              placeholder="新密码"
              maxlength="11"
            ></el-input>
            <p
              v-show="pwd_msg"
              style="position: absolute;bottom: -25px;left: 0;"
            >
              请输入新密码
            </p>
          </div>
          <el-button type="primary" @click="setPwd">提交</el-button>
        </div>
      </div>
    </div>
    <!-- <foot></foot> -->
    <div class="footer" style="bottom: 30px;padding-top: 15px;" v-if="PCshow">
      <div class="foot" style="height: 130px;">
        <p>
          声明：“杰宜斯云”服务为“武汉杰宜斯信息科技有限公司”为客户提供的增值服务平台，<br />
          该平台仅用于数据分析及展示，我司不会对客户数据进行抓取、存储，不会对客户数据进行盈利性商业活动，<br />
          所有开放行为均会在客户认可、自主的前提条件下进行，随时接受客户监督。
        </p>
      </div>
      <li class="f_bottom">
        Copyright © 2019 武汉杰宜斯信息科技有限公司<a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          >鄂ICP备14015145号-1</a
        >
      </li>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import hhead from '../../../components/header/index';
import nnav from '../../../components/nav/index';
import foot from '../../../components/footer/index';
import Sidentify from '../../../components/register/sidentify/index';
import './style.css';
export default {
  components: { hhead, nnav, foot },
  name: 'forgetpwd',
  components: { Sidentify },
  data() {
    return {
      loginRight: '360px',
      code_msg1: false,
      pwd_msg: false,
      phone: '',
      imgcode: '',
      phonecode: '',
      pwd: '',
      phone_msg: false,
      code_show: true,
      count: 60,
      code_msg: false,
      loginHeight: '',
      identifyCode: '',
      identifyCodes: 'abcdefghijklmnopqrstuvwxyz123456789',
      PCshow: '',
    };
  },

  mounted() {
    window.addEventListener('keydown', this.keyDown);
    if (
      window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPad|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      this.loginRight = '';
      this.loginHeight = document.documentElement.clientHeight + 'px';
      this.PCshow = false;
    } else {
      this.PCshow = true;
      this.loginHeight = document.documentElement.clientHeight - 180 + 'px';
      this.loginRight = '360px';
    }
    this.refreshCode();
  },
  methods: {
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    refreshCode() {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
      // console.log('当前验证码=', this.identifyCode);
    },
    setPwd() {
      // console.log(this.phone, this.phonecode, this.pwd);
      if (/^1[3456789]\d{9}$/.test(this.phone)) {
        if (this.imgcode == this.identifyCode) {
          this.code_msg = false;
          this.phone_msg = false;
          if (this.phonecode) {
            this.code_msg1 = false;
            this.$axios
              .post('/user_login_api/reset_pwd', {
                phone: this.phone,
                code: this.phonecode,
                newPwd: this.pwd,
                newPwdRe: this.pwd,
              })
              .then((res) => {
                // console.log(res);
                if (res.data.code == 200) {
                  this.$router.push('/login?type=login');
                } else if (res.data.code == 400 && this.pwd) {
                  this.code_msg1 = true;
                } else {
                  this.pwd_msg = true;
                }
              })
              .catch((err) => {
                // console.log(err);
              });
          } else {
            this.code_msg1 = true;
          }
        } else {
          this.code_msg = true;
        }
      } else {
        this.phone_msg = true;
      }
    },
    push() {
      this.$router.push('/');
    },

    getcode() {
      //获得短信验证码
      let that = this;
      if (/^1[3456789]\d{9}$/.test(this.phone)) {
        if (this.imgcode == this.identifyCode) {
          this.phone_msg = false;
          this.code_msg = false;
          this.$axios
            .post('/user_login_api/sendCode', {
              type: 'forget',
              mob: this.phone,
            })
            .then((res) => {
              // console.log(res);
              if (res.data.code == 200) {
                this.code_show = false;
                var Interval = setInterval(function() {
                  that.count--;
                }, 1000);

                setTimeout(function() {
                  that.code_show = true;
                  clearInterval(Interval);
                  that.count = 60;
                }, 60000);
                // console.log(res);
              }
            })
            .catch((err) => {
              // console.log(err);
            });
        } else {
          this.code_msg = true;
        }
      } else {
        this.phone_msg = true;
      }
    },
    phone_blur() {
      if (/^1[3456789]\d{9}$/.test(this.phone)) {
        this.phone_msg = false;
      } else {
        this.phone_msg = true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/login/forgetpwd/index.vue